<template>
  <div class="message-personal-card">
    <div class="message-personal-card__main">
      <div class="message-personal-card__info">
        <div class="message-personal-card__company">{{ companyName }}</div>
        <div class="message-personal-card__name">{{ personalName }}</div>
      </div>
      <img v-if="avatar" alt="" class="message-personal-card__avatar" :src="avatar" />
    </div>
    <div class="message-personal-card__footer">个人名片</div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  message: {
    type: Object,
    default: () => ({
      title: '',
      url: '',
      content: ''
    })
  }
})

const companyName = computed(() => props.message.title || '')
const personalName = computed(() => props.message.content || '')
const avatar = computed(() => props.message.url || '')
</script>

<style lang="scss" scoped>
.message-personal-card {
  box-sizing: border-box;
  width: 240px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #f2f3f5;
  border-radius: 8px;
}

.message-personal-card__main {
  box-sizing: border-box;
  display: flex;
  min-height: 76px;
  padding: 12px;
}

.message-personal-card__info {
  flex: 1;
  min-width: 0;
  margin-right: 12px;
}

.message-personal-card__company,
.message-personal-card__name {
  overflow: hidden;
  font-size: 14px;
  line-height: 20px;
  color: #323233;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.message-personal-card__name {
  margin-top: 12px;
  font-weight: 600;
}

.message-personal-card__avatar {
  flex: none;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  object-fit: cover;
}

.message-personal-card__footer {
  box-sizing: border-box;
  height: 24px;
  padding: 4px 12px;
  font-size: 12px;
  line-height: 16px;
  color: #969799;
  border-top: 1px solid #f2f3f5;
}
</style>
